module.exports = __webpack_public_path__ + "static/media/under_maintenance.9c850bee.gif";